// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".log_out_dropdown {\n  background: #005DFD !important;\n}", "",{"version":3,"sources":["webpack://src/components/DropDown/DropDown.scss"],"names":[],"mappings":"AAEA;EACI,8BAAA;AADJ","sourcesContent":["@import '../../main.scss';\n\n.log_out_dropdown {\n    background: $bg_blue  !important;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
